var map = {
	"./align-bottom-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-bottom-18.svg",
		0
	],
	"./align-center-x-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-center-x-18.svg",
		0
	],
	"./align-center-y-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-center-y-18.svg",
		0
	],
	"./align-justify-24.svg": [
		"../../packages/uneon/lib/Icon/icons/align-justify-24.svg",
		0
	],
	"./align-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-left-18.svg",
		0
	],
	"./align-right-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-right-18.svg",
		0
	],
	"./align-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-top-18.svg",
		0
	],
	"./align-x-baseline-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-baseline-18.svg",
		0
	],
	"./align-x-center-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-center-18.svg",
		0
	],
	"./align-x-center-full-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-center-full-18.svg",
		0
	],
	"./align-x-space-around-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-space-around-18.svg",
		0
	],
	"./align-x-space-between-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-space-between-18.svg",
		0
	],
	"./align-x-space-evenly-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-x-space-evenly-18.svg",
		0
	],
	"./align-y-center-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-y-center-18.svg",
		0
	],
	"./align-y-center-full-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-y-center-full-18.svg",
		0
	],
	"./align-y-space-around-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-y-space-around-18.svg",
		0
	],
	"./align-y-space-between-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-y-space-between-18.svg",
		0
	],
	"./align-y-space-evenly-18.svg": [
		"../../packages/uneon/lib/Icon/icons/align-y-space-evenly-18.svg",
		0
	],
	"./animation-24.svg": [
		"../../packages/uneon/lib/Icon/icons/animation-24.svg",
		0
	],
	"./arrow-down-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-down-18.svg",
		0
	],
	"./arrow-from-square-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-from-square-top-18.svg",
		0
	],
	"./arrow-reverse-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-reverse-left-18.svg",
		0
	],
	"./arrow-reverse-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-reverse-top-18.svg",
		0
	],
	"./arrow-right-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-right-18.svg",
		0
	],
	"./arrow-to-line-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-to-line-top-18.svg",
		0
	],
	"./arrow-to-line-top-30.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-to-line-top-30.svg",
		0
	],
	"./arrow-to-square-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-to-square-top-18.svg",
		0
	],
	"./arrow-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-top-18.svg",
		0
	],
	"./arrow-top-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-top-left-18.svg",
		0
	],
	"./arrow-zigzag-right-18.svg": [
		"../../packages/uneon/lib/Icon/icons/arrow-zigzag-right-18.svg",
		0
	],
	"./asterisk-18.svg": [
		"../../packages/uneon/lib/Icon/icons/asterisk-18.svg",
		0
	],
	"./bell-18.svg": [
		"../../packages/uneon/lib/Icon/icons/bell-18.svg",
		0
	],
	"./bold-18.svg": [
		"../../packages/uneon/lib/Icon/icons/bold-18.svg",
		0
	],
	"./browser-18.svg": [
		"../../packages/uneon/lib/Icon/icons/browser-18.svg",
		0
	],
	"./burger-color-24.svg": [
		"../../packages/uneon/lib/Icon/icons/burger-color-24.svg",
		0
	],
	"./calendar-18.svg": [
		"../../packages/uneon/lib/Icon/icons/calendar-18.svg",
		0
	],
	"./camera-18.svg": [
		"../../packages/uneon/lib/Icon/icons/camera-18.svg",
		0
	],
	"./cart-18.svg": [
		"../../packages/uneon/lib/Icon/icons/cart-18.svg",
		0
	],
	"./check-18.svg": [
		"../../packages/uneon/lib/Icon/icons/check-18.svg",
		0
	],
	"./click-18.svg": [
		"../../packages/uneon/lib/Icon/icons/click-18.svg",
		0
	],
	"./clip-18.svg": [
		"../../packages/uneon/lib/Icon/icons/clip-18.svg",
		0
	],
	"./clock-18.svg": [
		"../../packages/uneon/lib/Icon/icons/clock-18.svg",
		0
	],
	"./code-18.svg": [
		"../../packages/uneon/lib/Icon/icons/code-18.svg",
		0
	],
	"./code-24.svg": [
		"../../packages/uneon/lib/Icon/icons/code-24.svg",
		0
	],
	"./code-30.svg": [
		"../../packages/uneon/lib/Icon/icons/code-30.svg",
		0
	],
	"./copy-18.svg": [
		"../../packages/uneon/lib/Icon/icons/copy-18.svg",
		0
	],
	"./crop-18.svg": [
		"../../packages/uneon/lib/Icon/icons/crop-18.svg",
		0
	],
	"./cross-18.svg": [
		"../../packages/uneon/lib/Icon/icons/cross-18.svg",
		0
	],
	"./cross-24.svg": [
		"../../packages/uneon/lib/Icon/icons/cross-24.svg",
		0
	],
	"./delete-18.svg": [
		"../../packages/uneon/lib/Icon/icons/delete-18.svg",
		0
	],
	"./desktop-18.svg": [
		"../../packages/uneon/lib/Icon/icons/desktop-18.svg",
		0
	],
	"./desktop-24.svg": [
		"../../packages/uneon/lib/Icon/icons/desktop-24.svg",
		0
	],
	"./desktop-30.svg": [
		"../../packages/uneon/lib/Icon/icons/desktop-30.svg",
		0
	],
	"./direction-split-18.svg": [
		"../../packages/uneon/lib/Icon/icons/direction-split-18.svg",
		0
	],
	"./dot-18.svg": [
		"../../packages/uneon/lib/Icon/icons/dot-18.svg",
		0
	],
	"./dot-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/dot-stroke-18.svg",
		0
	],
	"./dots-corner-top-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/dots-corner-top-left-18.svg",
		0
	],
	"./dots-horizontal-3-18.svg": [
		"../../packages/uneon/lib/Icon/icons/dots-horizontal-3-18.svg",
		0
	],
	"./dots-horizontal-thin-6-18.svg": [
		"../../packages/uneon/lib/Icon/icons/dots-horizontal-thin-6-18.svg",
		0
	],
	"./droplet-18.svg": [
		"../../packages/uneon/lib/Icon/icons/droplet-18.svg",
		0
	],
	"./droplet-24.svg": [
		"../../packages/uneon/lib/Icon/icons/droplet-24.svg",
		0
	],
	"./erase-18.svg": [
		"../../packages/uneon/lib/Icon/icons/erase-18.svg",
		0
	],
	"./exclamation-point-18.svg": [
		"../../packages/uneon/lib/Icon/icons/exclamation-point-18.svg",
		0
	],
	"./expand-small-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/expand-small-top-18.svg",
		0
	],
	"./expand-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/expand-top-18.svg",
		0
	],
	"./external-18.svg": [
		"../../packages/uneon/lib/Icon/icons/external-18.svg",
		0
	],
	"./eye-18.svg": [
		"../../packages/uneon/lib/Icon/icons/eye-18.svg",
		0
	],
	"./eye-crossed-18.svg": [
		"../../packages/uneon/lib/Icon/icons/eye-crossed-18.svg",
		0
	],
	"./filter-18.svg": [
		"../../packages/uneon/lib/Icon/icons/filter-18.svg",
		0
	],
	"./font-preview-18.svg": [
		"../../packages/uneon/lib/Icon/icons/font-preview-18.svg",
		0
	],
	"./gap-x-18.svg": [
		"../../packages/uneon/lib/Icon/icons/gap-x-18.svg",
		0
	],
	"./gap-y-18.svg": [
		"../../packages/uneon/lib/Icon/icons/gap-y-18.svg",
		0
	],
	"./gear-18.svg": [
		"../../packages/uneon/lib/Icon/icons/gear-18.svg",
		0
	],
	"./gear-30.svg": [
		"../../packages/uneon/lib/Icon/icons/gear-30.svg",
		0
	],
	"./global-18.svg": [
		"../../packages/uneon/lib/Icon/icons/global-18.svg",
		0
	],
	"./help-18.svg": [
		"../../packages/uneon/lib/Icon/icons/help-18.svg",
		0
	],
	"./home-18.svg": [
		"../../packages/uneon/lib/Icon/icons/home-18.svg",
		0
	],
	"./image-18.svg": [
		"../../packages/uneon/lib/Icon/icons/image-18.svg",
		0
	],
	"./image-24.svg": [
		"../../packages/uneon/lib/Icon/icons/image-24.svg",
		0
	],
	"./image-30.svg": [
		"../../packages/uneon/lib/Icon/icons/image-30.svg",
		0
	],
	"./info-rounded-18.svg": [
		"../../packages/uneon/lib/Icon/icons/info-rounded-18.svg",
		0
	],
	"./italic-18.svg": [
		"../../packages/uneon/lib/Icon/icons/italic-18.svg",
		0
	],
	"./layout-18.svg": [
		"../../packages/uneon/lib/Icon/icons/layout-18.svg",
		0
	],
	"./layout-24.svg": [
		"../../packages/uneon/lib/Icon/icons/layout-24.svg",
		0
	],
	"./layout-30.svg": [
		"../../packages/uneon/lib/Icon/icons/layout-30.svg",
		0
	],
	"./lines -horizontal-3-18.svg": [
		"../../packages/uneon/lib/Icon/icons/lines -horizontal-3-18.svg",
		0
	],
	"./link-18.svg": [
		"../../packages/uneon/lib/Icon/icons/link-18.svg",
		0
	],
	"./list-18.svg": [
		"../../packages/uneon/lib/Icon/icons/list-18.svg",
		0
	],
	"./list-ordered-18.svg": [
		"../../packages/uneon/lib/Icon/icons/list-ordered-18.svg",
		0
	],
	"./list-unordered-18.svg": [
		"../../packages/uneon/lib/Icon/icons/list-unordered-18.svg",
		0
	],
	"./location-18.svg": [
		"../../packages/uneon/lib/Icon/icons/location-18.svg",
		0
	],
	"./lock-18.svg": [
		"../../packages/uneon/lib/Icon/icons/lock-18.svg",
		0
	],
	"./loudspeaker-18.svg": [
		"../../packages/uneon/lib/Icon/icons/loudspeaker-18.svg",
		0
	],
	"./mail-18.svg": [
		"../../packages/uneon/lib/Icon/icons/mail-18.svg",
		0
	],
	"./menu-18.svg": [
		"../../packages/uneon/lib/Icon/icons/menu-18.svg",
		0
	],
	"./minus-18.svg": [
		"../../packages/uneon/lib/Icon/icons/minus-18.svg",
		0
	],
	"./mobile-18.svg": [
		"../../packages/uneon/lib/Icon/icons/mobile-18.svg",
		0
	],
	"./mobile-24.svg": [
		"../../packages/uneon/lib/Icon/icons/mobile-24.svg",
		0
	],
	"./mobile-30.svg": [
		"../../packages/uneon/lib/Icon/icons/mobile-30.svg",
		0
	],
	"./page-18.svg": [
		"../../packages/uneon/lib/Icon/icons/page-18.svg",
		0
	],
	"./parameters-18.svg": [
		"../../packages/uneon/lib/Icon/icons/parameters-18.svg",
		0
	],
	"./pen-18.svg": [
		"../../packages/uneon/lib/Icon/icons/pen-18.svg",
		0
	],
	"./pen-24.svg": [
		"../../packages/uneon/lib/Icon/icons/pen-24.svg",
		0
	],
	"./phone-18.svg": [
		"../../packages/uneon/lib/Icon/icons/phone-18.svg",
		0
	],
	"./pipet-18.svg": [
		"../../packages/uneon/lib/Icon/icons/pipet-18.svg",
		0
	],
	"./play-18.svg": [
		"../../packages/uneon/lib/Icon/icons/play-18.svg",
		0
	],
	"./play-24.svg": [
		"../../packages/uneon/lib/Icon/icons/play-24.svg",
		0
	],
	"./play-30.svg": [
		"../../packages/uneon/lib/Icon/icons/play-30.svg",
		0
	],
	"./play-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/play-stroke-18.svg",
		0
	],
	"./plus-18.svg": [
		"../../packages/uneon/lib/Icon/icons/plus-18.svg",
		0
	],
	"./plus-24.svg": [
		"../../packages/uneon/lib/Icon/icons/plus-24.svg",
		0
	],
	"./plus-30.svg": [
		"../../packages/uneon/lib/Icon/icons/plus-30.svg",
		0
	],
	"./question-mark-18.svg": [
		"../../packages/uneon/lib/Icon/icons/question-mark-18.svg",
		0
	],
	"./question-rounded-18.svg": [
		"../../packages/uneon/lib/Icon/icons/question-rounded-18.svg",
		0
	],
	"./redo-18.svg": [
		"../../packages/uneon/lib/Icon/icons/redo-18.svg",
		0
	],
	"./refresh-18.svg": [
		"../../packages/uneon/lib/Icon/icons/refresh-18.svg",
		0
	],
	"./resize-top-bottom-18.svg": [
		"../../packages/uneon/lib/Icon/icons/resize-top-bottom-18.svg",
		0
	],
	"./restore-18.svg": [
		"../../packages/uneon/lib/Icon/icons/restore-18.svg",
		0
	],
	"./rhombus-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/rhombus-stroke-18.svg",
		0
	],
	"./rhombus-stroke-24.svg": [
		"../../packages/uneon/lib/Icon/icons/rhombus-stroke-24.svg",
		0
	],
	"./rhombus-stroke-30.svg": [
		"../../packages/uneon/lib/Icon/icons/rhombus-stroke-30.svg",
		0
	],
	"./search-18.svg": [
		"../../packages/uneon/lib/Icon/icons/search-18.svg",
		0
	],
	"./social-facebook-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-facebook-18.svg",
		0
	],
	"./social-facebook-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-facebook-24.svg",
		0
	],
	"./social-google-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-google-18.svg",
		0
	],
	"./social-google-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-google-24.svg",
		0
	],
	"./social-linkedin-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-linkedin-18.svg",
		0
	],
	"./social-linkedin-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-linkedin-24.svg",
		0
	],
	"./social-livejournal-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-livejournal-18.svg",
		0
	],
	"./social-livejournal-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-livejournal-24.svg",
		0
	],
	"./social-moy-mir-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-moy-mir-18.svg",
		0
	],
	"./social-moy-mir-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-moy-mir-24.svg",
		0
	],
	"./social-ok-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-ok-18.svg",
		0
	],
	"./social-ok-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-ok-24.svg",
		0
	],
	"./social-pinterest-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-pinterest-18.svg",
		0
	],
	"./social-pinterest-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-pinterest-24.svg",
		0
	],
	"./social-tumblr-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-tumblr-18.svg",
		0
	],
	"./social-tumblr-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-tumblr-24.svg",
		0
	],
	"./social-twitter-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-twitter-18.svg",
		0
	],
	"./social-twitter-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-twitter-24.svg",
		0
	],
	"./social-vkontakte-18.svg": [
		"../../packages/uneon/lib/Icon/icons/social-vkontakte-18.svg",
		0
	],
	"./social-vkontakte-24.svg": [
		"../../packages/uneon/lib/Icon/icons/social-vkontakte-24.svg",
		0
	],
	"./speech-bubble-18.svg": [
		"../../packages/uneon/lib/Icon/icons/speech-bubble-18.svg",
		0
	],
	"./square-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-18.svg",
		0
	],
	"./square-corner-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-corner-18.svg",
		0
	],
	"./square-corners-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-corners-18.svg",
		0
	],
	"./square-side-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-side-18.svg",
		0
	],
	"./square-side-24.svg": [
		"../../packages/uneon/lib/Icon/icons/square-side-24.svg",
		0
	],
	"./square-side-30.svg": [
		"../../packages/uneon/lib/Icon/icons/square-side-30.svg",
		0
	],
	"./square-side-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-side-top-18.svg",
		0
	],
	"./square-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-stroke-18.svg",
		0
	],
	"./square-top-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/square-top-left-18.svg",
		0
	],
	"./squares-4-18.svg": [
		"../../packages/uneon/lib/Icon/icons/squares-4-18.svg",
		0
	],
	"./squares-9-18.svg": [
		"../../packages/uneon/lib/Icon/icons/squares-9-18.svg",
		0
	],
	"./squares-horizontal-top-2-18.svg": [
		"../../packages/uneon/lib/Icon/icons/squares-horizontal-top-2-18.svg",
		0
	],
	"./star-18.svg": [
		"../../packages/uneon/lib/Icon/icons/star-18.svg",
		0
	],
	"./star-24.svg": [
		"../../packages/uneon/lib/Icon/icons/star-24.svg",
		0
	],
	"./star-30.svg": [
		"../../packages/uneon/lib/Icon/icons/star-30.svg",
		0
	],
	"./star-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/star-stroke-18.svg",
		0
	],
	"./stop-18.svg": [
		"../../packages/uneon/lib/Icon/icons/stop-18.svg",
		0
	],
	"./stop-stroke-18.svg": [
		"../../packages/uneon/lib/Icon/icons/stop-stroke-18.svg",
		0
	],
	"./strikethrough-18.svg": [
		"../../packages/uneon/lib/Icon/icons/strikethrough-18.svg",
		0
	],
	"./subscript-18.svg": [
		"../../packages/uneon/lib/Icon/icons/subscript-18.svg",
		0
	],
	"./superscript-18.svg": [
		"../../packages/uneon/lib/Icon/icons/superscript-18.svg",
		0
	],
	"./tablet-18.svg": [
		"../../packages/uneon/lib/Icon/icons/tablet-18.svg",
		0
	],
	"./tablet-24.svg": [
		"../../packages/uneon/lib/Icon/icons/tablet-24.svg",
		0
	],
	"./tablet-30.svg": [
		"../../packages/uneon/lib/Icon/icons/tablet-30.svg",
		0
	],
	"./text-align-center-18.svg": [
		"../../packages/uneon/lib/Icon/icons/text-align-center-18.svg",
		0
	],
	"./text-align-justify-18.svg": [
		"../../packages/uneon/lib/Icon/icons/text-align-justify-18.svg",
		0
	],
	"./text-align-left-18.svg": [
		"../../packages/uneon/lib/Icon/icons/text-align-left-18.svg",
		0
	],
	"./text-align-right-18.svg": [
		"../../packages/uneon/lib/Icon/icons/text-align-right-18.svg",
		0
	],
	"./transition.svg": [
		"../../packages/uneon/lib/Icon/icons/transition.svg",
		0
	],
	"./trash-18.svg": [
		"../../packages/uneon/lib/Icon/icons/trash-18.svg",
		0
	],
	"./triangle-top-18.svg": [
		"../../packages/uneon/lib/Icon/icons/triangle-top-18.svg",
		0
	],
	"./unavailable-18.svg": [
		"../../packages/uneon/lib/Icon/icons/unavailable-18.svg",
		0
	],
	"./underline-18.svg": [
		"../../packages/uneon/lib/Icon/icons/underline-18.svg",
		0
	],
	"./undo-18.svg": [
		"../../packages/uneon/lib/Icon/icons/undo-18.svg",
		0
	],
	"./unlink-18.svg": [
		"../../packages/uneon/lib/Icon/icons/unlink-18.svg",
		0
	],
	"./unlock-18.svg": [
		"../../packages/uneon/lib/Icon/icons/unlock-18.svg",
		0
	],
	"./user-18.svg": [
		"../../packages/uneon/lib/Icon/icons/user-18.svg",
		0
	],
	"./widget-button-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-button-18.svg",
		0
	],
	"./widget-captcha-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-captcha-18.svg",
		0
	],
	"./widget-card-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-card-18.svg",
		0
	],
	"./widget-code-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-code-18.svg",
		0
	],
	"./widget-custom-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-custom-18.svg",
		0
	],
	"./widget-form-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-form-18.svg",
		0
	],
	"./widget-gallery-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-gallery-18.svg",
		0
	],
	"./widget-heading-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-heading-18.svg",
		0
	],
	"./widget-icon-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-icon-18.svg",
		0
	],
	"./widget-image-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-image-18.svg",
		0
	],
	"./widget-input-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-input-18.svg",
		0
	],
	"./widget-rectangle-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-rectangle-18.svg",
		0
	],
	"./widget-spacer-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-spacer-18.svg",
		0
	],
	"./widget-stack-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-stack-18.svg",
		0
	],
	"./widget-text-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-text-18.svg",
		0
	],
	"./widget-textarea-18.svg": [
		"../../packages/uneon/lib/Icon/icons/widget-textarea-18.svg",
		0
	],
	"./yin-and-yang-18.svg": [
		"../../packages/uneon/lib/Icon/icons/yin-and-yang-18.svg",
		0
	],
	"./zoom-in-18.svg": [
		"../../packages/uneon/lib/Icon/icons/zoom-in-18.svg",
		0
	],
	"./zoom-out-18.svg": [
		"../../packages/uneon/lib/Icon/icons/zoom-out-18.svg",
		0
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../packages/uneon/lib/Icon/icons lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;